<template>
  <div>
    <ModalCargando texto="Configurando cuenta, por favor espere" v-if="loader" />

    <formulario-base class="auto-form-wrapper" :error="error">
      <form v-if="muestraFormTel" slot="formulario" autocomplete="off">
        <div class="form-group">
          <label class="label">Télefono móvil</label>
          <div class="form-row">
            <div class="form-group col-md-12">
              <select name="countryCode" @change="cambioDePais" class="form-control custom-select" id="countryCode" v-model="prefijo">
                <option data-country-code="MX" data-valueid="143" value="52" selected>México (+52)</option>
                <option data-country-code="US" data-valueid="235" value="1">USA (+1)</option>
                <optgroup label="Otros">
                  <option data-country-code="DZ" data-valueid="4" value="213">Algeria (+213)</option>
                  <option data-country-code="AD" data-valueid="6" value="376">Andorra (+376)</option>
                  <option data-country-code="AO" data-valueid="7" value="244">Angola (+244)</option>
                  <option data-country-code="AI" data-valueid="8" value="1264">Anguilla (+1264)</option>
                  <option data-country-code="AG" data-valueid="10" value="1268">Antigua &amp; Barbuda (+1268)</option>
                  <option data-country-code="AR" data-valueid="11" value="54">Argentina (+54)</option>
                  <option data-country-code="AM" data-valueid="12" value="374">Armenia (+374)</option>
                  <option data-country-code="AW" data-valueid="13" value="297">Aruba (+297)</option>
                  <option data-country-code="AU" data-valueid="14" value="61">Australia (+61)</option>
                  <option data-country-code="AT" data-valueid="15" value="43">Austria (+43)</option>
                  <option data-country-code="AZ" data-valueid="16" value="994">Azerbaijan (+994)</option>
                  <option data-country-code="BS" data-valueid="17" value="1242">Bahamas (+1242)</option>
                  <option data-country-code="BH" data-valueid="18" value="973">Bahrain (+973)</option>
                  <option data-country-code="BD" data-valueid="19" value="880">Bangladesh (+880)</option>
                  <option data-country-code="BB" data-valueid="20" value="1246">Barbados (+1246)</option>
                  <option data-country-code="BY" data-valueid="21" value="375">Belarus (+375)</option>
                  <option data-country-code="BE" data-valueid="22" value="32">Belgium (+32)</option>
                  <option data-country-code="BZ" data-valueid="23" value="501">Belize (+501)</option>
                  <option data-country-code="BJ" data-valueid="24" value="229">Benin (+229)</option>
                  <option data-country-code="BM" data-valueid="25" value="1441">Bermuda (+1441)</option>
                  <option data-country-code="BT" data-valueid="26" value="975">Bhutan (+975)</option>
                  <option data-country-code="BO" data-valueid="27" value="591">Bolivia (+591)</option>
                  <option data-country-code="BA" data-valueid="29" value="387">Bosnia Herzegovina (+387)</option>
                  <option data-country-code="BW" data-valueid="30" value="267">Botswana (+267)</option>
                  <option data-country-code="BR" data-valueid="32" value="55">Brazil (+55)</option>
                  <option data-country-code="BN" data-valueid="34" value="673">Brunei (+673)</option>
                  <option data-country-code="BG" data-valueid="35" value="359">Bulgaria (+359)</option>
                  <option data-country-code="BF" data-valueid="36" value="226">Burkina Faso (+226)</option>
                  <option data-country-code="BI" data-valueid="37" value="257">Burundi (+257)</option>
                  <option data-country-code="KH" data-valueid="38" value="855">Cambodia (+855)</option>
                  <option data-country-code="CM" data-valueid="39" value="237">Cameroon (+237)</option>
                  <option data-country-code="CA" data-valueid="40" value="1">Canada (+1)</option>
                  <option data-country-code="CV" data-valueid="41" value="238">Cape Verde Islands (+238)</option>
                  <option data-country-code="KY" data-valueid="42" value="1345">Cayman Islands (+1345)</option>
                  <option data-country-code="CF" data-valueid="43" value="236">Central African Republic (+236)</option>
                  <option data-country-code="CL" data-valueid="45" value="56">Chile (+56)</option>
                  <option data-country-code="CN" data-valueid="46" value="86">China (+86)</option>
                  <option data-country-code="CO" data-valueid="49" value="57">Colombia (+57)</option>
                  <option data-country-code="KM" data-valueid="50" value="269">Comoros (+269)</option>
                  <option data-country-code="CG" data-valueid="51" value="242">Congo (+242)</option>
                  <option data-country-code="CK" data-valueid="53" value="682">Cook Islands (+682)</option>
                  <option data-country-code="CR" data-valueid="54" value="506">Costa Rica (+506)</option>
                  <option data-country-code="HR" data-valueid="56" value="385">Croatia (+385)</option>
                  <option data-country-code="CU" data-valueid="57" value="53">Cuba (+53)</option>
                  <option data-country-code="CY" data-valueid="59" value="90392">Cyprus North (+90392)</option>
                  <option data-country-code="CY" data-valueid="59" value="357">Cyprus South (+357)</option>
                  <option data-country-code="CZ" data-valueid="60" value="42">Czech Republic (+42)</option>
                  <option data-country-code="DK" data-valueid="61" value="45">Denmark (+45)</option>
                  <option data-country-code="DJ" data-valueid="62" value="253">Djibouti (+253)</option>
                  <option data-country-code="DM" data-valueid="63" value="1809">Dominica (+1809)</option>
                  <option data-country-code="DO" data-valueid="64" value="1809">Dominican Republic (+1809)</option>
                  <option data-country-code="EC" data-valueid="65" value="593">Ecuador (+593)</option>
                  <option data-country-code="EG" data-valueid="66" value="20">Egypt (+20)</option>
                  <option data-country-code="SV" data-valueid="67" value="503">El Salvador (+503)</option>
                  <option data-country-code="GQ" data-valueid="68" value="240">Equatorial Guinea (+240)</option>
                  <option data-country-code="ER" data-valueid="69" value="291">Eritrea (+291)</option>
                  <option data-country-code="EE" data-valueid="70" value="372">Estonia (+372)</option>
                  <option data-country-code="ET" data-valueid="71" value="251">Ethiopia (+251)</option>
                  <option data-country-code="FK" data-valueid="72" value="500">Falkland Islands (+500)</option>
                  <option data-country-code="FO" data-valueid="73" value="298">Faroe Islands (+298)</option>
                  <option data-country-code="FJ" data-valueid="74" value="679">Fiji (+679)</option>
                  <option data-country-code="FI" data-valueid="75" value="358">Finland (+358)</option>
                  <option data-country-code="FR" data-valueid="76" value="33">France (+33)</option>
                  <option data-country-code="GF" data-valueid="77" value="594">French Guiana (+594)</option>
                  <option data-country-code="PF" data-valueid="78" value="689">French Polynesia (+689)</option>
                  <option data-country-code="GA" data-valueid="80" value="241">Gabon (+241)</option>
                  <option data-country-code="GM" data-valueid="81" value="220">Gambia (+220)</option>
                  <option data-country-code="GE" data-valueid="82" value="7880">Georgia (+7880)</option>
                  <option data-country-code="DE" data-valueid="83" value="49">Germany (+49)</option>
                  <option data-country-code="GH" data-valueid="84" value="233">Ghana (+233)</option>
                  <option data-country-code="GI" data-valueid="85" value="350">Gibraltar (+350)</option>
                  <option data-country-code="GR" data-valueid="86" value="30">Greece (+30)</option>
                  <option data-country-code="GL" data-valueid="87" value="299">Greenland (+299)</option>
                  <option data-country-code="GD" data-valueid="88" value="1473">Grenada (+1473)</option>
                  <option data-country-code="GP" data-valueid="89" value="590">Guadeloupe (+590)</option>
                  <option data-country-code="GU" data-valueid="90" value="671">Guam (+671)</option>
                  <option data-country-code="GT" data-valueid="91" value="502">Guatemala (+502)</option>
                  <option data-country-code="GN" data-valueid="93" value="224">Guinea (+224)</option>
                  <option data-country-code="GW" data-valueid="94" value="245">Guinea - Bissau (+245)</option>
                  <option data-country-code="GY" data-valueid="95" value="592">Guyana (+592)</option>
                  <option data-country-code="HT" data-valueid="96" value="509">Haiti (+509)</option>
                  <option data-country-code="HN" data-valueid="99" value="504">Honduras (+504)</option>
                  <option data-country-code="HK" data-valueid="100" value="852">Hong Kong (+852)</option>
                  <option data-country-code="HU" data-valueid="101" value="36">Hungary (+36)</option>
                  <option data-country-code="IS" data-valueid="102" value="354">Iceland (+354)</option>
                  <option data-country-code="IN" data-valueid="103" value="91">India (+91)</option>
                  <option data-country-code="ID" data-valueid="104" value="62">Indonesia (+62)</option>
                  <option data-country-code="IR" data-valueid="105" value="98">Iran (+98)</option>
                  <option data-country-code="IQ" data-valueid="106" value="964">Iraq (+964)</option>
                  <option data-country-code="IE" data-valueid="107" value="353">Ireland (+353)</option>
                  <option data-country-code="IL" data-valueid="109" value="972">Israel (+972)</option>
                  <option data-country-code="IT" data-valueid="110" value="39">Italy (+39)</option>
                  <option data-country-code="JM" data-valueid="111" value="1876">Jamaica (+1876)</option>
                  <option data-country-code="JP" data-valueid="112" value="81">Japan (+81)</option>
                  <option data-country-code="JO" data-valueid="114" value="962">Jordan (+962)</option>
                  <option data-country-code="KZ" data-valueid="115" value="7">Kazakhstan (+7)</option>
                  <option data-country-code="KE" data-valueid="116" value="254">Kenya (+254)</option>
                  <option data-country-code="KI" data-valueid="117" value="686">Kiribati (+686)</option>
                  <option data-country-code="KP" data-valueid="118" value="850">Korea North (+850)</option>
                  <option data-country-code="KR" data-valueid="118" value="82">Korea South (+82)</option>
                  <option data-country-code="KW" data-valueid="119" value="965">Kuwait (+965)</option>
                  <option data-country-code="KG" data-valueid="120" value="996">Kyrgyzstan (+996)</option>
                  <option data-country-code="LA" data-valueid="0000" value="856">Laos (+856)</option>
                  <option data-country-code="LV" data-valueid="122" value="371">Latvia (+371)</option>
                  <option data-country-code="LB" data-valueid="123" value="961">Lebanon (+961)</option>
                  <option data-country-code="LS" data-valueid="124" value="266">Lesotho (+266)</option>
                  <option data-country-code="LR" data-valueid="125" value="231">Liberia (+231)</option>
                  <option data-country-code="LY" data-valueid="126" value="218">Libya (+218)</option>
                  <option data-country-code="LI" data-valueid="127" value="417">Liechtenstein (+417)</option>
                  <option data-country-code="LT" data-valueid="128" value="370">Lithuania (+370)</option>
                  <option data-country-code="LU" data-valueid="129" value="352">Luxembourg (+352)</option>
                  <option data-country-code="MO" data-valueid="130" value="853">Macao (+853)</option>
                  <option data-country-code="MK" data-valueid="131" value="389">Macedonia (+389)</option>
                  <option data-country-code="MG" data-valueid="132" value="261">Madagascar (+261)</option>
                  <option data-country-code="MW" data-valueid="133" value="265">Malawi (+265)</option>
                  <option data-country-code="MY" data-valueid="134" value="60">Malaysia (+60)</option>
                  <option data-country-code="MV" data-valueid="135" value="960">Maldives (+960)</option>
                  <option data-country-code="ML" data-valueid="136" value="223">Mali (+223)</option>
                  <option data-country-code="MT" data-valueid="137" value="356">Malta (+356)</option>
                  <option data-country-code="MH" data-valueid="138" value="692">Marshall Islands (+692)</option>
                  <option data-country-code="MQ" data-valueid="139" value="596">Martinique (+596)</option>
                  <option data-country-code="MR" data-valueid="140" value="222">Mauritania (+222)</option>
                  <option data-country-code="YT" data-valueid="142" value="269">Mayotte (+269)</option>
                  <option data-country-code="MX" data-valueid="143" value="52">Mexico (+52)</option>
                  <option data-country-code="FM" data-valueid="144" value="691">Micronesia (+691)</option>
                  <option data-country-code="MD" data-valueid="145" value="373">Moldova (+373)</option>
                  <option data-country-code="MC" data-valueid="146" value="377">Monaco (+377)</option>
                  <option data-country-code="MN" data-valueid="147" value="976">Mongolia (+976)</option>
                  <option data-country-code="MS" data-valueid="149" value="1664">Montserrat (+1664)</option>
                  <option data-country-code="MA" data-valueid="150" value="212">Morocco (+212)</option>
                  <option data-country-code="MZ" data-valueid="151" value="258">Mozambique (+258)</option>
                  <option data-country-code="MN" data-valueid="152" value="95">Myanmar (+95)</option>
                  <option data-country-code="NA" data-valueid="153" value="264">Namibia (+264)</option>
                  <option data-country-code="NR" data-valueid="154" value="674">Nauru (+674)</option>
                  <option data-country-code="NP" data-valueid="155" value="977">Nepal (+977)</option>
                  <option data-country-code="NL" data-valueid="156" value="31">Netherlands (+31)</option>
                  <option data-country-code="NC" data-valueid="157" value="687">New Caledonia (+687)</option>
                  <option data-country-code="NZ" data-valueid="158" value="64">New Zealand (+64)</option>
                  <option data-country-code="NI" data-valueid="159" value="505">Nicaragua (+505)</option>
                  <option data-country-code="NE" data-valueid="160" value="227">Niger (+227)</option>
                  <option data-country-code="NG" data-valueid="161" value="234">Nigeria (+234)</option>
                  <option data-country-code="NU" data-valueid="162" value="683">Niue (+683)</option>
                  <option data-country-code="NF" data-valueid="163" value="672">Norfolk Islands (+672)</option>
                  <option data-country-code="NP" data-valueid="164" value="670">Northern Marianas (+670)</option>
                  <option data-country-code="NO" data-valueid="165" value="47">Norway (+47)</option>
                  <option data-country-code="OM" data-valueid="166" value="968">Oman (+968)</option>
                  <option data-country-code="PW" data-valueid="168" value="680">Palau (+680)</option>
                  <option data-country-code="PA" data-valueid="170" value="507">Panama (+507)</option>
                  <option data-country-code="PG" data-valueid="171" value="675">Papua New Guinea (+675)</option>
                  <option data-country-code="PY" data-valueid="172" value="595">Paraguay (+595)</option>
                  <option data-country-code="PE" data-valueid="173" value="51">Peru (+51)</option>
                  <option data-country-code="PH" data-valueid="174" value="63">Philippines (+63)</option>
                  <option data-country-code="PL" data-valueid="176" value="48">Poland (+48)</option>
                  <option data-country-code="PT" data-valueid="177" value="351">Portugal (+351)</option>
                  <option data-country-code="PR" data-valueid="178" value="1787">Puerto Rico (+1787)</option>
                  <option data-country-code="QA" data-valueid="179" value="974">Qatar (+974)</option>
                  <option data-country-code="RE" data-valueid="180" value="262">Reunion (+262)</option>
                  <option data-country-code="RO" data-valueid="181" value="40">Romania (+40)</option>
                  <option data-country-code="RU" data-valueid="182" value="7">Russia (+7)</option>
                  <option data-country-code="RW" data-valueid="183" value="250">Rwanda (+250)</option>
                  <option data-country-code="SM" data-valueid="192" value="378">San Marino (+378)</option>
                  <option data-country-code="ST" data-valueid="193" value="239">Sao Tome &amp; Principe (+239)</option>
                  <option data-country-code="SA" data-valueid="194" value="966">Saudi Arabia (+966)</option>
                  <option data-country-code="SN" data-valueid="195" value="221">Senegal (+221)</option>
                  <option data-country-code="CS" data-valueid="196" value="381">Serbia (+381)</option>
                  <option data-country-code="SC" data-valueid="197" value="248">Seychelles (+248)</option>
                  <option data-country-code="SL" data-valueid="198" value="232">Sierra Leone (+232)</option>
                  <option data-country-code="SG" data-valueid="199" value="65">Singapore (+65)</option>
                  <option data-country-code="SK" data-valueid="201" value="421">Slovak Republic (+421)</option>
                  <option data-country-code="SI" data-valueid="202" value="386">Slovenia (+386)</option>
                  <option data-country-code="SB" data-valueid="203" value="677">Solomon Islands (+677)</option>
                  <option data-country-code="SO" data-valueid="204" value="252">Somalia (+252)</option>
                  <option data-country-code="ZA" data-valueid="205" value="27">South Africa (+27)</option>
                  <option data-country-code="ES" data-valueid="208" value="34">Spain (+34)</option>
                  <option data-country-code="LK" data-valueid="209" value="94">Sri Lanka (+94)</option>
                  <option data-country-code="SH" data-valueid="0000" value="290">St. Helena (+290)</option>
                  <option data-country-code="KN" data-valueid="0000" value="1869">St. Kitts (+1869)</option>
                  <option data-country-code="SC" data-valueid="0000" value="1758">St. Lucia (+1758)</option>
                  <option data-country-code="SD" data-valueid="210" value="249">Sudan (+249)</option>
                  <option data-country-code="SR" data-valueid="211" value="597">Suriname (+597)</option>
                  <option data-country-code="SZ" data-valueid="213" value="268">Swaziland (+268)</option>
                  <option data-country-code="SE" data-valueid="214" value="46">Sweden (+46)</option>
                  <option data-country-code="CH" data-valueid="215" value="41">Switzerland (+41)</option>
                  <option data-country-code="SI" data-valueid="216" value="963">Syria (+963)</option>
                  <option data-country-code="TW" data-valueid="217" value="886">Taiwan (+886)</option>
                  <option data-country-code="TJ" data-valueid="218" value="7">Tajikstan (+7)</option>
                  <option data-country-code="TH" data-valueid="220" value="66">Thailand (+66)</option>
                  <option data-country-code="TG" data-valueid="222" value="228">Togo (+228)</option>
                  <option data-country-code="TO" data-valueid="224" value="676">Tonga (+676)</option>
                  <option data-country-code="TT" data-valueid="225" value="1868">Trinidad &amp; Tobago (+1868)</option>
                  <option data-country-code="TN" data-valueid="226" value="216">Tunisia (+216)</option>
                  <option data-country-code="TR" data-valueid="227" value="90">Turkey (+90)</option>
                  <option data-country-code="TM" data-valueid="228" value="7">Turkmenistan (+7)</option>
                  <option data-country-code="TM" data-valueid="228" value="993">Turkmenistan (+993)</option>
                  <option data-country-code="TC" data-valueid="29" value="1649">Turks &amp; Caicos Islands (+1649)</option>
                  <option data-country-code="TV" data-valueid="230" value="688">Tuvalu (+688)</option>
                  <option data-country-code="UG" data-valueid="231" value="256">Uganda (+256)</option>
                  <!-- <option data-countryCode="GB" value="44">UK (+44)</option> -->
                  <option data-country-code="UA" data-valueid="232" value="380">Ukraine (+380)</option>
                  <option data-country-code="AE" data-valueid="233" value="971">United Arab Emirates (+971)</option>
                  <option data-country-code="UY" data-valueid="237" value="598">Uruguay (+598)</option>
                  <!-- <option data-countryCode="US" value="1">USA (+1)</option> -->
                  <option data-country-code="UZ" data-valueid="238" value="7">Uzbekistan (+7)</option>
                  <option data-country-code="VU" data-valueid="239" value="678">Vanuatu (+678)</option>
                  <option data-country-code="VA" data-valueid="0000" value="379">Vatican City (+379)</option>
                  <option data-country-code="VE" data-valueid="240" value="58">Venezuela (+58)</option>
                  <option data-country-code="VN" data-valueid="241" value="84">Vietnam (+84)</option>
                  <option data-country-code="VG" data-valueid="242" value="84">Virgin Islands - British (+1284)</option>
                  <option data-country-code="VI" data-valueid="243" value="84">Virgin Islands - US (+1340)</option>
                  <option data-country-code="WF" data-valueid="244" value="681">Wallis &amp; Futuna (+681)</option>
                  <option data-country-code="YE" data-valueid="246" value="969">Yemen (North)(+969)</option>
                  <option data-country-code="YE" data-valueid="246" value="967">Yemen (South)(+967)</option>
                  <option data-country-code="ZM" data-valueid="247" value="260">Zambia (+260)</option>
                  <option data-country-code="ZW" data-valueid="248" value="263">Zimbabwe (+263)</option>
                </optgroup>
              </select>
            </div>
            <div class="form-group col-md-12">
              <input
                v-model="telefono"
                type="tel"
                name="phone"
                :class="{'rojo': this.errorNombre,
                  'form-control': true}"
                placeholder="Teléfono"
                autocomplete="tel"
              >
            </div>
          </div>
          <label class="error">{{errorNombre}}</label>
        </div>
        <div v-show="muestraReCaptchaDiv">
          <div id="rcc"></div>
        </div>
        <br>
        <div class="form-group">
          <button
            :disabled="!reCaptchaOk"
            class="btn btn-primary submit-btn btn-block"
            @click.prevent="registrarNumeroTel"
          >Enviar código de verificación</button>
        </div>
        <div class="form-group d-flex justify-content-center link-style">
          <router-link to="/" class="forgot-password">¿Ya tiene una cuenta?</router-link>
        </div>
      </form>

      <form v-if="muestraFormCode" slot="formulario">
        <div class="form-group">
          <label class="label">Introduce el código de verificación enviado por SMS</label>
          <div class="input-group">
            <input
              v-model="codigo"
              type="text"
              :class="{'rojo': 
                            this.errorNombre,
                            'form-control': true}"
              placeholder="Código de verificación"
            >
          </div>
          <label class="error">{{errorNombre}}</label>
        </div>
        <div class="form-group">
          <button
            class="btn btn-primary submit-btn btn-block"
            @click.prevent="verificarCodigo"
          >Verificar</button>
        </div>
        <div class="form-group d-flex justify-content-center">
          <a href="#" class="forgot-password active" @click.prevent="reenviarCodigo">Volver a iniciar</a>
          <!-- <router-link :to="{ name: 'login' }" class="forgot-password">¿Ya tiene una cuenta?</router-link> -->
        </div>
      </form>

      <form v-if="muestraAvisoCuenta" slot="formulario">
        <div class="form-group text-center">
          <h3>Cuenta existente</h3>
          <label class="title">Ya existe una cuenta relacionada a este número</label>
        </div>
        <div class="form-group">
          <button
            class="btn btn-primary submit-btn btn-block"
            @click.prevent="btnIngresarPressed"
          >Ingresar</button>
        </div>
        <div class="form-group d-flex justify-content-center"></div>
      </form>

      <form v-if="muestraFormDatos" action="#" slot="formulario" autocomplete="off">
        <div class="form-group">
          <label class="label">Nombre</label>
          <div class="input-group">
            <input
              v-model="nombreCompleto"
              id="nombre"
              type="text"
              name="name"
              :class="{'rojo': 
                            this.errorNombre,
                            'form-control': true}"
              placeholder="Nombre"
              autocomplete="given-name"
            >
          </div>
          <label class="error">{{errorNombre}}</label>
        </div>
        <div class="form-group">
          <label class="label">Apellidos</label>
          <div class="input-group">
            <input
            id="apellido"
              v-model="apellidos"
              type="text"
              name="lastname"
              :class="{'rojo': 
                            this.errorApellidos,
                            'form-control': true}"
              placeholder="Apellidos"
              autocomplete="family-name"
            >
          </div>
          <label class="error">{{errorApellidos}}</label>
        </div>
        <div class="form-group">
          <label class="label">País</label>
          <div class="input-group">
            <b-form-select @change="onChangePaisDirec" v-model="paisCliente" id="selecionPais" :options="paisesCombo"/>
          </div>
          <label class="error">{{errorApellidos}}</label>
        </div>

        <div v-if="paisCliente == 13">
          <div class="form-group">
            <label class="label">Estado</label>
            <div class="input-group">
              <b-form-select @change="cambioEstado" v-model="estadoCliente" :options="estadosCombo" />
            </div>
          </div>
          <div class="form-group">
            <label class="label">Municipio</label>
            <div class="input-group">
              <b-form-select v-model="municipioCliente" :options="municipiosCombo"/>
            </div>
          </div>
        </div>
        <div v-else>
          <b-form-group label="Estado" label-for="input2">
            <b-form-input v-model="estado_personalizado" type="text" placeholder="Estado"></b-form-input>
          </b-form-group>
          <b-form-group label="Municipio" label-for="input2">
            <b-form-input v-model="municipio_personalizado" type="text" placeholder="Municipio"></b-form-input>
          </b-form-group>
        </div>


        <div class="form-group">
          <label class="label">Correo electrónico</label>
          <div class="input-group">
            <input
            id="correoRegistro"
              v-model="email"
              type="email"
              name="email"
              class="form-control"
              placeholder="Correo electrónico"
              autocomplete="email"
            >
          </div>
          <label class="error"></label>
        </div>

        <div class="form-group">
          <label class="label">Teléfono</label>
          <div class="input-group">
            <input
              v-model="telefono"
              id="telefono"
              type="tel"
              name="phone"
              :class="{'rojo': this.errorNombre,
                'form-control': true}"
              placeholder="Teléfono"
              autocomplete="tel"
            >
          </div>
          <label class="error"></label>
        </div>


        <div class="form-group">
          <label class="label">Contraseña</label>
          <div class="input-group">
            <input
              v-model="password"
              id="password"
              type="password"
              name="password"
              :class="{'rojo': 
                this.errorPassword,
                'form-control': true}"
              placeholder="*********"
              autocomplete="new-password"
              style="width: 100%;display: block;"
            >
            <div  class="small-gray mt-2">Mínimo de 6 caracteres alfanúmerico </div>
          </div>
          <label class="error">{{errorPassword}}</label>
        </div>
        <div class="form-group">
          <label class="label">Repetir contraseña</label>
          <div class="input-group">
            <input
            id="password2"
              v-model="repetirPassword"
              type="password"
              name="password2"
              :class="{'rojo': 
                this.errorPassword,
                'form-control': true}"
              placeholder="*********"
              autocomplete="new-password"
            >
          </div>

          <label class="error"></label>
        </div>


        <!--<b-form-group label="Elige tu plan" label-for="plan" id="plan">
          <b-form-radio-group>
            <b-form-radio value="gratis"> 
                <small>Gratuito</small>
            </b-form-radio><br>
            <b-form-radio value="semestral"> 
                <small>Semestral: 6 +1 meses <span>$3,900 MXN</span></small>
            </b-form-radio><br>
            <b-form-radio value="anual">
                <small>Anual: 12 +1 meses <span>$7,200 MXN</span></small>
            </b-form-radio>
          </b-form-radio-group>
        </b-form-group>-->



        <div class="form-group">
          <button
            class="btn btn-primary submit-btn btn-block"
            @click.prevent="crearUsuario" id="botonSiguiente"
          >Siguiente</button>
        </div>
        <div class="form-group d-flex justify-content-center">
          <!-- <router-link to="/login" class="forgot-password">¿Ya tiene una cuenta?</router-link>-->
        </div>
      </form>
      <form v-if="muestraCargando" slot="formulario">
        <div class="form-group text-center">
          <h3>Creando cuenta</h3>
          <label class="title">Esto puede tardar algunos segundos, espera por favor...</label>
        </div>
        <div class="form-group d-flex justify-content-center"></div>
      </form>
    </formulario-base>
  </div>
</template>

<script>
import $ from 'jquery';
import { TIPO_NOTIFICACION, TIPO_PERFIL } from "@/constantes/usuarios.js";
import FormularioBase from "./FormBase.vue";
import { mixinFormulario } from "@/mixins/mixins";
import errors from "../../errors";
import firebase from "../../firebase";
import { mapActions } from "vuex";
import { STATUS_APP } from "@/constantes/usuarios.js";
import { truncate } from "fs";
import moment from 'moment';
import { paises } from "@/constantes/paises.js";
import { estados } from '@/constantes/estados.js'
import { municipios } from '@/constantes/municipios.js'
import axios from "axios";
import {PRODUCCION, URL_CLUDSF} from '@/constantes/environment'


export default {
  components: { 
    FormularioBase,
    ModalCargando: () => import('@/componentes/cargando/modalCargando'),
  },
  mixins: [mixinFormulario],
  data() {
    return {
      loader: false,
      telefono: "",
      prefijo: "52",
      codigo: "",
      muestraFormTel: false,
      muestraFormCode: false,
      muestraFormDatos: true,
      muestraAvisoCuenta: false,
      muestraCargando: false,
      reCaptchaOk: false,
      muestraReCaptchaDiv: true,
      errorApellidos: "",
      errorPassword: "",
      errorNombre: "",
      apellidos: "",
      nombreCompleto: "",
      repetirPassword: "",
      paisCliente: '13',
      estadoCliente: null,
      municipioCliente: null,
      estado_personalizado: "",
      municipio_personalizado: "",
      //notif
      usuarioNotif: "",
      tipoNotif: "Inmediata",

      valorEstadoLista: ''
    };
  },
  mounted() {
    console.log("inicio");
    this.crearReCaptcha();

  },
  computed: {
    paisesCombo() {
      return paises.map(pais => {
        return { value: pais.id, text: pais.name };
      });
    },
    estadosCombo () {
      return estados.map(estado => {
        return {value: estado.id, text: estado.name }
      })
    }, 
    municipiosCombo () {
      console.log('municipiossss', this.valorEstadoLista)
      if (this.valorEstadoLista === undefined) {
        return []
      }
      var idEstado = this.valorEstadoLista
      let mun = municipios.filter(m => {
        return m.state_id === idEstado
        })
      return mun.map(mun => {
        return {value: mun.id, text: mun.name }
      })
    }
  },
  methods: {
    ...mapActions([
      "cargaInicialUsuario",
      "crearComplementoUsuario",
      "cambiaStatusApp",
      'enviarNTF'
    ]),
    cambioEstado(valor){
      console.log('municipiossss', valor)
      this.valorEstadoLista = valor;
    },
    onChangePaisDirec(event){
      if(event == 13){
        this.estadoCliente = null
        this.municipioCliente = null
      }else{
        this.estadoCliente = null
        this.municipioCliente = null
      }

    },
    crearReCaptcha() {
      // FIXME: Remover la siguiente línea en producción
      //firebase.auth().settings.appVerificationDisabledForTesting = true;
      window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier("rcc", {
        size: "normal",
        callback: response => {
          // reCAPTCHA solved, allow signInWithPhoneNumber.
          // ...
          this.reCaptchaOk = true;
          console.log("Solved: ");
        },
        "expired-callback": () => {
          // Response expired. Ask user to solve reCAPTCHA again.
          // ...
          this.reCaptchaOk = false;
          console.log("expired");
        }
      });
      window.recaptchaVerifier.render().then(widgetId => {
        window.recaptchaWidgetId = widgetId;
      });
    },
    registrarNumeroTel() {
      if (this.telefono == "" || this.telefono == undefined) {
        alert("Introduce un número válido");
        return;
      }
      this.muestraReCaptchaDiv = false;
      var telefonoConPrefijo = "+" + this.prefijo + this.telefono;
      console.log("telefono: " + telefonoConPrefijo);
      var phoneNumber = telefonoConPrefijo;
      var appVerifier = window.recaptchaVerifier;
      firebase
        .auth()
        .signInWithPhoneNumber(phoneNumber, appVerifier)
        .then(confirmationResult => {
          // SMS sent. Prompt user to type the code from the message, then sign the
          // user in with confirmationResult.confirm(code).

          console.log(confirmationResult);
          this.muestraFormTel = false;
          this.muestraFormCode = true;
          this.reCaptchaOk = false;
          console.log("SMS enviado");
          window.confirmationResult = confirmationResult;
        })
        .catch(error => {
          // Error; SMS not sent
          // ...
          window.recaptchaVerifier.reset(window.recaptchaWidgetId);
          console.log("SMS Error");
          console.log(error);

          this.error = errors(error.code);
        });
    },
    reenviarCodigo() {
      //this.crearReCaptcha();
      console.log("reenviarCodigo");
      location.reload();
      //window.location.reload(true);
      //this.muestraReCaptchaDiv = true;
      //window.recaptchaVerifier.reset(window.recaptchaWidgetId);

      //this.muestraPantalla("muestraFormTel");
    },
    verificarCodigo() {
      var code = this.codigo;
      confirmationResult
        .confirm(code)
        .then(result => {
          // User signed in successfully.
          var user = result.user;
          console.log("Todo chido");
          console.log(result);

          if (result.additionalUserInfo.isNewUser) {
            this.muestraPantalla("muestraFormDatos");
          } else {
            this.muestraPantalla("muestraAvisoCuenta");
          }

          /* 
          this.muestraFormCode = false;
          this.muestraFormTel = false;
          this.muestraFormDatos = true; */
          // ...additionalUserInfo
        })
        .catch(error => {
          console.log("Error al verificar el codigo");
          // User couldn't sign in (bad verification code?)
          // ...
          this.error = errors(error.code);
        });
    },
    muestraPantalla(pantalla) {
      this.muestraFormCode = false;
      this.muestraFormTel = false;
      this.muestraFormDatos = false;
      this.muestraAvisoCuenta = false;
      this.muestraCargando = false;
      this[pantalla] = true;
    },
    async crearUsuario() {
      this.errorApellidos = "";
      this.errorPassword = "";
      this.errorNombre = "";
      var valido = true;
      if (this.nombreCompleto.length == 0) {
        this.errorNombre = "Falta ingresar el campo nombre";
        valido = false;
      }
      if (this.apellidos.length == 0) {
        this.errorApellidos = "Falta ingresar el campo apellidos";
        valido = false;
      }
      if (this.password.length < 6) {
        this.errorPassword = "La contraseña debe tener 6 caracteres minimos";
        valido = false;
      }
      if (this.password !== this.repetirPassword) {
        this.errorPassword = "Las contraseñas no coinciden";
        valido = false;
      }
      if (valido) {
        //SE LANZA EL MODAL DEL LOADER
        this.loader = true;

        var nuevoUsuario = {};
        this.cargandoFormulario = true;
        nuevoUsuario.nombreCompleto = this.nombreCompleto;
        nuevoUsuario.password = this.password;
        nuevoUsuario.email = this.email;
        nuevoUsuario.apellidos = this.apellidos;
        var telefonoConPrefijo = "+" + this.prefijo + this.telefono;
        nuevoUsuario.celular = telefonoConPrefijo;
        nuevoUsuario.foto = "";
        nuevoUsuario.pais = Number(this.paisCliente)
        nuevoUsuario.estado = Number(this.estadoCliente)
        nuevoUsuario.municipio = Number(this.municipioCliente)

        nuevoUsuario.estado_personalizado = this.estado_personalizado;
        nuevoUsuario.municipio_personalizado = this.municipio_personalizado;

        console.log(nuevoUsuario);
        // var credential = firebase.auth().createUserWithEmailAndPassword(nuevoUsuario.email, nuevoUsuario.password)
        // .then((userCredential) => {
        //   var user = userCredential.user;
        // });
        const dataJsonUsuario = JSON.stringify(nuevoUsuario);

        let urlCrearUsuario = URL_CLUDSF+'/wsCrearUsuario';
        
        const res = await axios.post(urlCrearUsuario, dataJsonUsuario, {
          headers: {
            'Content-Type': 'application/json'
          }
        });
        console.log('respuesta firebase',res.data);

        if(res.data.error){
          if(res.data.error.code == "auth/email-already-exists"){
            this.cargandoFormulario = false;
            this.loader = false;
            this.$swal("Upps!","Este correo ya está registrado.","error");
            return false;
          }
        }

        if(res.data.status){
          nuevoUsuario.uid = res.data.id; //id usuario creado
          this.configInicialUsuario(nuevoUsuario);
        }else{
          this.$swal("Upps!","Ocurrió un error inesperado, contáctanos.","error");
          return false;
        }
        
      }
    },

    //aca es para obtener el user de la db
    configInicialUsuario(nuevoUsuario) {

      this.cambiaStatusApp(STATUS_APP.CONFIGURACION_INICIAL)

      this.muestraPantalla("muestraCargando");
      this.cargandoFormulario = false;
      
      /*
      this.cargaInicialUsuario(nuevoUsuario.uid).then(
        usuario => {
          console.log("Todo correcto >> cargamos datos de inicio ");
          console.log("usuario: ");
          console.log(usuario);

          this.loader = false;
          //envio de notificacion inmediata al que se registro
          this.usuarioNotif = nuevoUsuario.uid
          //this.enviarNotificacion()
          //this.enviarNotificacionAdministrador();

          console.log("todo bien con el usuario nuevo");
          this.cambiaStatusApp(STATUS_APP.ACTIVA);
          this.$router.push("/inicio");
        }
      ).catch(error => {
        this.loader = false;
        this.cargandoFormulario = false;
        this.error = errors(error.code);
        console.log(error);
      });*/


      this.$store
        .dispatch("loginCorreo", {
          email: this.email,
          password: this.password
        })
        .then(user => {
          console.log("TCL: loginCorreo -> user", user)
          this.usuarioNotif = user.id
          this.enviarNotificacion()
          this.enviarNotificacionAdministrador();
          this.cargandoFormulario = false;
          this.cambiaStatusApp(STATUS_APP.ACTIVA);
        })
        .catch(error => {
          this.loader = false;
          this.cargandoFormulario = false;
          this.error = errors(error.code);
          console.log(error);
        });


       
    },





    btnIngresarPressed() {
      this.$router.push("/inicio");
    },
    enviarNotificacion() {
      // Notificación Programada
      let notificacionUsuario = {
        // Nombre del documento con la fecha si es programada
        //fecha: "2019-06-22",
        fecha: moment().format("YYYY-MM-DD"),
        //tipo: TIPO_NOTIFICACION.INMEDIATA,
        tipo: this.tipoNotif,
        modulo: 'registro',
        info: {
          enviada: false,
          id: this.usuarioNotif,

          perfil: TIPO_PERFIL.USUARIO,
          tipo: ["Mail"],
          data: {
            asunto: "Bienvenido a Pixan Cloud",
            texto: `Estimado/a ${this.nombreCompleto} ${this.apellidos}, gracias por registrarte en Pixan Cloud.`,
            contenido: `Estimado/a ${this.nombreCompleto} ${this.apellidos} <br><br>
              Gracias por registrarte en Pixan Cloud. <br>
              Con esta plataforma podrás administrar de forma sencilla y rápida la operación de tu clínica, estética o consultorio veterinario. <br>
              Te invitamos a conocer más de esta plataforma en <a href="https://app.pixancloud.com">https://app.pixancloud.com</a> <br> <br>
              Atte. Equipo Pixan Cloud`
          }
        }
      };
      this.enviarNTF(notificacionUsuario);
    },
    enviarNotificacionAdministrador() {
      // Notificación Programada
      let notificacionUsuario = {
        // Nombre del documento con la fecha si es programada
        //fecha: "2019-06-22",
        fecha: moment().format("YYYY-MM-DD"),
        //tipo: TIPO_NOTIFICACION.INMEDIATA,
        tipo: this.tipoNotif,
        modulo: 'registro',
        info: {
          enviada: false,
          id: 'Imixusn4YFag4VRJcZdZMIvuCIM2', //ID DE CUENTA DE SQUENDA

          perfil: TIPO_PERFIL.USUARIO,
          tipo: ["Mail"],
          data: {
            asunto: "Registro de nueva cuenta",
            texto: `Nuevo Registro de nueva cuenta.`,
            contenido: `Hola <br><br>
              Hay un registro nuevo en Pixan Cloud. <br>
              Nombre: <b>${this.nombreCompleto} ${this.apellidos}</b> <br>
              Correo: <b>${this.email}</b> <br>
              Telefono: <b>${this.telefono}</b> <br>
              <br> <br>
              Atte. Equipo Pixan Cloud`
          }
        }
      };
      this.enviarNTF(notificacionUsuario);
    },
    cambioDePais(e){
      if(e.target.options.selectedIndex > -1) {
          let paisSeleccionado = e.target.options[e.target.options.selectedIndex].dataset.valueid
          console.log("TCL: cambioDePais -> paisSeleccionado", paisSeleccionado)
          this.paisCliente = paisSeleccionado;
      }
    }



  }// FIN  METODOS
};
</script>

<style scoped>
#plan .custom-control-label{
  padding-top:5px;
}
</style>



// WEBPACK FOOTER //
// src/vistas/Auth/FormRegistrar.vue